import React, { useId } from "react";
import useModal from "components/modal/useModal";
import Button from "components/button";
import ModalCloseButton from "components/modal/components/closeButton";
import Tooltip from "components/tooltips/Tooltips";
import { AppProDownload, AppProPitch, useAppProLabel } from "components/modal/dataModal/data/ModalAppPro/AppProContent";

/** Side panel version: the pitch, then the QR code and the stores, under the panels' header and footer. */
const PanelAppPro = () => {
    const { toggle } = useModal();
    const label = useAppProLabel();
    const titleId = useId();
    const close = () => toggle();

    return (
        <div role="dialog" aria-modal="true" aria-labelledby={titleId} className="flex h-full min-h-0 flex-col">
            <div className="flex justify-end px-6 pt-5">
                <Tooltip text={label("close", "Fermer")} placement="bottom">
                    <ModalCloseButton onClick={close} label={label("close", "Fermer")} />
                </Tooltip>
            </div>
            <div className="flex min-h-0 flex-1 flex-col gap-8 overflow-y-auto px-6 pb-6">
                <AppProPitch titleId={titleId} />
                <AppProDownload />
            </div>
            <div className="flex justify-end border-t border-gray-100 px-6 py-4">
                <Button size={"LG"} color={"SECONDARY"} onClick={close}>
                    {label("close", "Fermer")}
                </Button>
            </div>
        </div>
    );
};

export default PanelAppPro;
